import React, { useState } from 'react';
import { INotificationPageProps } from './notification.type';
import { NotificationItem } from './components';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNotification } from './notification.hook';
import { Helmet } from 'react-helmet-async';
import Loading from '../../components/loading/loading.component';
import _ from 'lodash';
import { Spin } from 'antd';
import { EmptyComponent } from '../../components/empty/empty-component';

export const NotificationPage: React.FC<INotificationPageProps> = (props) => {
  const { isDropdown } = props;
  const [isAll, setIsAll] = useState<boolean>(true);
  const {
    notificationItems,
    isEndFetchingNotification,
    fetchNotification,
    isLoadingNotification,
  } = useNotification(isAll, true);
  const refreshNotifications = () => {
    fetchNotification(isAll, true);
  };
  return (
    <div
      className={`notification-page flex justify-center ${
        !isDropdown && 'py-6'
      }`}
    >
      <Helmet>
        {/* <title>Notification Page</title>
        <meta name="home" content="Notification Page" /> */}
      </Helmet>
      <div
        className={`${
          !isDropdown &&
          'flex border rounded-2xl border-[#DEE0E6] dark:border-slate-700 w-full max-w-[956px] flex-col '
        }`}
      >
        {!isDropdown && (
          <h1 className="font-semibold text-[22px] leading-6 text-[#18191E] px-4 py-3">
            Thông báo
          </h1>
        )}
        <div className="flex px-4 py-2 gap-3">
          <div
            onClick={() => setIsAll(true)}
            className={`px-4 cursor-pointer py-[10px] border text-4 leading-5 rounded-[100px] ${
              isAll ? 'text-white bg-[#0071A6]' : 'bg-white text-[#0071A6]'
            } border-[#0071A6]`}
          >
            Tất cả
          </div>
          <div
            onClick={() => setIsAll(false)}
            className={`px-4 cursor-pointer py-[10px] border text-4 leading-5 rounded-[100px] ${
              !isAll ? 'text-white bg-[#0071A6]' : 'bg-white text-[#0071A6]'
            } border-[#0071A6]`}
          >
            Chưa đọc
          </div>
        </div>
        <div className={`w-full h-full  ${!isDropdown && 'py-6 px-4'} `}>
          {isLoadingNotification ? (
            <div className="flex justify-center items-center">
              <Spin />
            </div>
          ) : notificationItems?.length > 0 ? (
            <InfiniteScroll
              dataLength={notificationItems?.length || 0}
              next={() => fetchNotification(isAll, false)}
              hasMore={isEndFetchingNotification}
              loader={
                <div className="flex justify-center items-center">
                  <Loading />
                </div>
              }
              endMessage={null}
              className={`flex flex-col  max-h-[calc(100vh-278px)]  ${
                !isDropdown && 'gap-3'
              }`}
            >
              {_.map(notificationItems, (rc, index) => (
                <div key={_.get(rc, 'id', '') + index}>
                  <NotificationItem
                    notification={rc}
                    imageUrl={_.get(rc, 'actor.avatar')}
                    content={_.get(rc, 'message')}
                    timeStamp={_.get(rc, 'createdAt')}
                    userName={_.get(rc, 'actor.fullName')}
                    onRead={refreshNotifications}
                  />
                </div>
              ))}
            </InfiniteScroll>
          ) : (
            <EmptyComponent />
          )}
        </div>
      </div>
    </div>
  );
};
